<template>
  <div>
    <div v-show="childData.length>0" class="hotSpeak">
      <div v-for="(item,index) in childData" :key="index" :class="index===childData.length-1?'lastspeakBox':'speakBox'">
        <div class="userIMG">
          <img v-if="item.USER_PHOTO" :src="item.USER_PHOTO" alt="">
          <img v-else :src="userDefault" alt="">
        </div>
        <div class="createName">
          <span class="names">{{ item.USER_NAME }} </span>
          <p class="createSource">
            {{ item.SPEAK_SOURCE }}
          </p>
          <div v-if="item.SPEAK_PARENT_ID == parentID" class="content">
            {{ item.SPEAK_CONTENT }}
          </div>
          <div v-else class="content">
            <span style="color:#2394ff;">@{{ item.SPEAK_PARENT_USER_NAME }}</span>{{ item.SPEAK_CONTENT }}
          </div>
          <div class="footbox">
            <span class="times">{{ item.CREATE_DATE|changeSpeak }}</span>
            <p class="rightmsg">
              <span style="display: none"><svg-icon icon-class="zan" />赞{{ item.PRAISE_SIZE|changenum }}</span>
              <span @click="huifu(index)"><svg-icon icon-class="huifu" class="hui" />回复</span>
            </p>
          </div>
        </div>
        <div v-show="!item.fold" class="huifuInput">
          <div class="sanjiao" />
          <textarea v-model="textcontent" :placeholder="['回复@'+item.USER_NAME+':']" class="speakMsg2" />
          <el-button @click="fabuhuifu(item.SPEAK_ID,index)">
            发布
          </el-button>
          <span class="quxiao" @click="quxiao(index)">取消回复</span>
        </div>
      </div>
      <div v-show="!isloadAll" class="loadMore" @click="addmore()">
        加载更多>>
      </div>
      <div v-show="isloadAll" class="loadMore">
        已经到底部啦
      </div>
    </div>
  </div>
</template>

<script>
import { readSpeak, addSpeak } from '@/api/api.js'
import { ssoUserLogin } from '@/api/api.js'
import Vue from 'vue'
export default {
  inject: ['reload'],
  props: ['parentID', 'content'],
  data() {
    return {
      userDefault: require('@/static/usuerDefault.png'),
      childData: [],
      textcontent: '',
      page: 1,
      isloadAll: false
    }
  },
  watch: {
    parentID: function(newval, oldval) {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init: function() {
      var obj = {}
      obj.contentId = this.content
      obj.speakParentId = this.parentID
      obj.index = '1'
      obj.size = '5'
      readSpeak(obj).then(res => {
        if (res.data.count > 0) {
          this.childData = res.data.listMapData
          for (let i = 0; i < this.childData.length; i++) {
            var item = this.childData[i]
            item.fold = true
          }
        } else {
          this.childData = []
        }
        if (res.data.count < 4) {
          this.isloadAll = true
        }
      })
    },
    huifu: function(index) {
      for (let i = 0; i < this.childData.length; i++) {
        this.childData[i].fold = true
      }
      this.childData[index].fold = false
      Vue.set(this.childData, index, this.childData[index])
    },
    quxiao: function(index) {
      this.textcontent = ''
      this.childData[index].fold = !this.childData[index].fold
      Vue.set(this.childData, index, this.childData[index])
    },
    fabuhuifu: function(id, index) {
      var obj = {}
      obj.contentId = this.content
      obj.speakParentId = id
      obj.speakContent = this.textcontent
      obj.speakType = 1
      ssoUserLogin().then(res => {
        if (res.data.userId) {
          this.setloca('userid', res.data.userId, 7200)
          localStorage.removeItem('unionid')
          if (obj.speakContent) {
            addSpeak(obj).then(res => {
              for (let i = 0; i < this.childData.length; i++) {
                this.childData[i].fold = true
              }
              Vue.set(this.childData, index, this.childData[index])
              if (res.data) {
                this.$message({
                  showClose: true,
                  message: '恭喜您，评论成功',
                  type: 'success'
                })
                this.textcontent = ''
                this.reload()
              } else {
                this.$message({
                  showClose: true,
                  message: '评论失败请稍后再试',
                  type: 'warning'
                })
              }
            })
          } else {
            this.$message({
              showClose: true,
              message: '请输入评论内容',
              type: 'warning'
            })
          }
        } else {
          localStorage.removeItem('userid')
          localStorage.removeItem('unionid')
          this.$emit('showlogins')
        }
      })
    },
    addmore: function() {
      var obj = {}
      this.page++
      obj.contentId = this.content
      obj.speakParentId = this.parentID
      obj.index = this.page + ''
      obj.size = '5'
      readSpeak(obj).then(res => {
        var newArry = res.data.listMapData
        for (let i = 0; i < newArry.length; i++) {
          var item = newArry[i]
          item.fold = true
        }
        this.childData = this.childData.concat(newArry)
        if (res.data.listMapData.length < 4) {
          this.isloadAll = true
        }
      })
    }

  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .hotSpeak{
        margin: 20px 0;
        margin-left: 20px;
        .lastspeakBox{
            position:relative;
            margin-top: 20px;
            overflow: hidden;
            padding-bottom: 20px;
        }
        .speakBox{
            position:relative;
            margin-top: 20px;
            overflow: hidden;
            padding-bottom: 20px;
            border-bottom: 1px solid #e5e5e5;
        }
        .huifuInput{
          margin-top: 15px;
            position: relative;
            overflow: hidden;
            .sanjiao{
                display: inline-block;
                position: absolute;
                bottom: 178px;
                width: 18px;
                height:18px;
                left: 722px;
                background-color: #fff;
                border-left: 1px  solid #e5e5e5;
                border-top: 1px  solid #e5e5e5;
                -webkit-transform:rotate(45deg);
            }
            .quxiao{
                display: inline-block;
                float: right;
                margin-top: 12px;
                color: #b2b2b2;
                width: 86px;
                height: 35px;
                line-height: 35px;
                cursor: pointer;
                &:hover{
                    color: #ed4040;
                }
            }
            .el-button{
                border: 1px solid #ed4040;
                float: right;
                margin-top: 10px;
                margin-right: 20px;
                color: #ed4040;
                width: 86px;
                display: inline-block;
                line-height: 10px;
                &:hover{
                    background-color: #ed4040;
                    color: #ffffff;
                }
            }
        }
    }
    .hotSpeak{
        .userIMG{
            width: 38px;
            height: 38px;
            border-radius: 50%;
            background-color: red;
            float: left;
          overflow: hidden;
          img{
            width: 38px;
            height: 38px;
          }
        }
        .createName{
            overflow: hidden;
            line-height: 25px;
          margin-left: 47px;
            .names{
                font-size: 15px;
                cursor: pointer;
                color: #456eb3;
                margin-left: 10px;
            }
            p{
                display: inline-block;
                font-size: 12px;
                color: #b2b2b2;
                margin-left: 5px;
            }
            .content{
                color: #656565;
                font-size: 14px;
                margin-left: 10px;
            }
            .footbox{
                margin-top: 10px;
                margin-left: 10px;
                color: #b2b2b2;
                .times{
                    font-size: 13px;
                    display: inline-block;
                }
                .rightmsg{
                    float: right;
                    display: inline-block;
                    span{
                        margin-left: 5px;
                        font-size: 14px;
                      cursor: pointer;
                        .hui{
                            height: 25px;
                            vertical-align: bottom;
                            cursor: pointer;
                            &:hover{
                                color: #ed4040;
                            }
                        }
                        svg{
                            font-size: 19px;
                            margin-left: 5px;
                        }
                    }
                }
            }
        }
      .speakBox{
        margin-top: 20px;
      }
      .speakMsg2{
        height: 115px;
        outline: none;
        width: 100%;
        padding: 10px 15px;
        box-sizing: border-box;
        border-color: #e5e5e5;
        resize:none;
      }
        .loadMore{
            display: block;
            font-size: 12px;
            color: #b2b2b2;
            cursor: pointer;
            text-align: center;
            &:hover{
             color: #ed4040;
            }
        }

    }

</style>
